<template>
  <div class="pt-4">
    <div class="row">
      <div class="col-lg-4 col-md-6 mb-4">
        <b-card no-body>
          <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center">
              <h6 class="mb-0">零件品牌</h6>
              <b-button
                squared
                variant="manage_main"
                type="button"
                v-b-modal.modalCategory
                @click="showModal('add')"
                >新增</b-button
              >
            </div>
            <b-input-group class="mt-3 mb-2 ml-auto search-group">
              <b-input-group-prepend is-text>
                <b-icon-search></b-icon-search>
              </b-input-group-prepend>
              <b-form-input
                v-model="searchPart"
                placeholder="搜尋零件品牌"
              ></b-form-input>
              <b-button-close
                class="pr-2"
                v-if="searchPart"
                @click="clearPartFilter"
              ></b-button-close>
            </b-input-group>
          </template>
          <b-list-group flush>
            <template v-if="filteredPartList && filteredPartList.length > 0">
              <b-list-group-item
                v-for="item in filteredPartList"
                :key="item.id"
                class="d-flex justify-content-between align-items-center"
              >
                {{ item.name }}
                <b-dropdown
                  right
                  no-caret
                  variant="link"
                  boundary="viewport"
                  class="btn-only-icon"
                >
                  <template v-slot:button-content>
                    <b-icon icon="three-dots-vertical" variant="dark"></b-icon>
                  </template>
                  <b-dropdown-item @click.stop="showModal('edit', item.id)"
                    >編輯</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="!item.count"
                    @click.stop="deletePart(item.id)"
                    link-class="text-danger"
                    >刪除</b-dropdown-item
                  >
                </b-dropdown>
              </b-list-group-item>
            </template>
            <b-list-group-item class="text-center" v-else>
              {{
                searchPart ? "沒有找到符合的零件品牌" : "目前尚無資料，請新增"
              }}
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </div>
    </div>
    <b-modal
      id="modalCategory"
      :title="modal.title"
      footer-class="d-flex justify-content-between"
      no-close-on-backdrop
      centered
      tall
      size="sm"
      @ok="onSubmit"
      @show="onShowModal"
      @hidden="onHiddenModal"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          :label="modal.labelName"
          label-for="categorName"
          :invalid-feedback="invalidFeedback"
          :state="modal.state.name"
          class="required"
        >
          <b-form-input
            id="categorName"
            class="rounded-0"
            v-model="modal.form.name"
            type="text"
            required
            :state="modal.state.name"
          ></b-form-input>
        </b-form-group>
      </form>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button squared variant="outline-dark" type="button" @click="cancel()"
          >取消</b-button
        >
        <b-button squared variant="manage_main" type="submit" @click="ok()"
          >儲存</b-button
        >
      </template>
    </b-modal>
  </div>
</template>
<style lang="scss" scoped>
.list-group {
  height: 316px;
  overflow-y: auto;
  @include media-breakpoint-down(sm) {
    height: 344px;
  }
}
.list-group-item.active {
  background-color: #d8e0f5;
  border: 1px solid $manage_main;
  color: $manage_main;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 1px;
}
.search-group {
  border: 1px solid #bdbdbd;
  max-width: 100%;
  margin-top: 20px;
  .input-group-text {
    background-color: #fff;
    border: none;
    border-radius: 0;
    color: #bdbdbd;
  }
  .form-control {
    border: none;
    border-radius: 0;
    &:focus {
      box-shadow: none;
    }
  }
}
</style>

<script>
import { Category } from "@/assets/api/manage.js";

import { Toast, Swal } from "@/plugins/sweetalert2.js";

export default {
  name: "CategoryPartBrand",
  props: ["isMobile", "token"],
  data() {
    return {
      searchPart: "",
      part: null,
      isEdit: false,
      isModalShow: false,
      invalidFeedback: "請填寫零件品牌名稱",
      modal: {
        id: null,
        title: "",
        labelName: "",
        state: {
          name: null
        },
        form: {
          name: ""
        }
      }
    };
  },
  created() {
    this.apiGetCarPart();
  },
  computed: {
    filteredPartList() {
      if (!this.part) return;
      return this.part.filter(data => {
        return data.name.toLowerCase().includes(this.searchPart.toLowerCase());
      });
    }
  },
  methods: {
    clearPartFilter() {
      this.searchPart = "";
    },
    resetForm() {
      this.modal.form.name = "";
      this.modal.state.name = null;
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.checkFormState();
      return valid;
    },
    checkFormState() {
      this.modal.form.name
        ? (this.modal.state.name = null)
        : (this.modal.state.name = false);
    },
    apiGetCarPart() {
      Category.part_brand
        .get("", this.token)
        .then(res => {
          if (res.status <= 201) {
            this.part = res.data;
          } else {
            Toast.fire({
              icon: "error",
              title: "汽車品牌資料讀取失敗",
              text: res.data.error
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    deletePart(partId) {
      Swal.fire({
        title: "刪除",
        text: "確定要刪除？",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "取消",
        confirmButtonText: "刪除"
      }).then(result => {
        if (result.value) {
          Category.part_brand
            .del(partId, this.token)
            .then(res => {
              if (res.status <= 201) {
                this.apiGetCarPart();
                Toast.fire({
                  icon: "success",
                  title: "刪除成功"
                });
              } else {
                Toast.fire({
                  icon: "error",
                  title: "刪除失敗",
                  text: res.data.error
                });
              }
            })
            .catch(error => {
              console.error(error);
            });
        }
      });
    },
    showModal(action, id) {
      this.modal.id = id;
      if (action === "edit") {
        this.isEdit = true;
        this.modal.title = "編輯零件品牌";
        this.modal.labelName = "零件品牌名稱";
        this.part.forEach(element => {
          if (element.id == id) {
            this.modal.form.name = element.name;
          }
        });
      } else {
        this.isEdit = false;
        this.modal.title = "新增零件品牌";
        this.modal.labelName = "零件品牌名稱";
      }
      this.$root.$emit("bv::show::modal", "modalCategory", "#btnShow");
    },
    onShowModal() {
      this.isModalShow = true;
    },
    onHiddenModal() {
      this.isModalShow = false;
      this.resetForm();
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.handleSubmit();
    },
    handleSubmit() {
      if (!this.checkFormValidity()) {
        return;
      }
      if (this.isEdit) {
        Category.part_brand
          .update(this.modal.id, { name: this.modal.form.name }, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "編輯成功"
              });
              this.$root.$emit("bv::hide::modal", "modalCategory", "#btnShow");
              this.apiGetCarPart();
            } else {
              this.modal.state.name = false;
              this.invalidFeedback = res.data.error;
            }
          })
          .catch(function(error) {
            this.modal.state.name = false;
            this.invalidFeedback = error;
          });
      } else {
        Category.part_brand
          .create({ name: this.modal.form.name }, this.token)
          .then(res => {
            if (res.status <= 201) {
              Toast.fire({
                icon: "success",
                title: "新增成功"
              });
              this.$root.$emit("bv::hide::modal", "modalCategory", "#btnShow");
              this.apiGetCarPart();
            } else {
              this.modal.state.name = false;
              this.invalidFeedback = res.data.error;
            }
          })
          .catch(function(error) {
            this.modal.state.name = false;
            this.invalidFeedback = error;
          });
      }
    }
  }
};
</script>
